<template>
  <div id="Breadcrumbs">     
     <v-row>
        <v-col cols="12">
          <nav class="menubar">           
                  <router-link to="/" class="breadcrumb">
                    <v-icon>dashboard</v-icon> Dashboard
                  </router-link>
                  <span class="breadcrumb"> {{ breadcrumbs.page }}</span>                  
                </nav>
        </v-col>
      </v-row>      
  </div>
</template>

<script>
import{ mapState } from "vuex";

export default {
  name: "Breadcrumbs",
  computed:{
    ...mapState(['breadcrumbs']),
  },
  methods:{    
  },
  data() {
    return {
      sword:'All'
    };
  }
};
</script>
<style>
nav.menubar {
    color: #fff;
    /* background-color: #29b6f6; */
    background-color:  #fff;
    border: gray;
    width: 100%;
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    box-shadow:none;
}
nav.menubar > a {
    color: gray;
}
</style>